import { Injectable } from '@angular/core';
import {environment} from "../../../../environments/environment";
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class FeedbackService {
  baseURL = environment.baseUrl + 'feedback';

  constructor(private http: HttpClient) {
  }


  updateUrl(eventId: any,url:any): Observable<any> {
    const params = new HttpParams()
      .set('url',url)
    return this.http.put<any>(`${this.baseURL}/event/`+eventId,{},{params});
  }

  getUrl(eventId:any){
    return this.http.get<any>(`${this.baseURL}/event/`+eventId);
  }
}
